// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodeHourAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodeHourAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis',
)({
  component: EnergyTreeNodeHourAnalysisPage,
});
